<template>
  <a :href="getAvailableLink(item)" class="content-item" target="_blank">
    <div class="content-item__content">
        <p class='content-item__eyebrow' v-html="getCategories(item)">
      <h2 class="content-item__title" v-html="item.Title"></h2>
      <p class="content-item__summary" v-html="item.Summary"></p>
      <div class="content-item__date">
        <span>{{ formatDate(item.PublishDate, item.EndDate) }}</span>
        <i v-if="getAvailableLink(item) != ''" class="fa fa-arrow-right"></i>
      </div>
    </div>
  </a>
</template>

<script>
    import moment from 'moment';
    import he from 'he';
    import {mapState, mapActions, mapMutations} from 'vuex';

    export default {
        props: ['item'],

        filters: {
            formatDate(value) {
                if (value) {
                    return moment(value).format('MMM DD, YYYY');
                }
            },
            formatTopicArray(value) {
                return value.map(topic => {
                    let lastSegment = topic.split('/').filter(Boolean).pop(); // Get last segment
                    return lastSegment
                        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add spaces between camelCase
                        .replace(/_/g, ' '); // Replace underscores with spaces
                }).join(', ');
            },
            decode(value) {
                return he.decode(value);
            }
        },
        computed: {
            ...mapState({
                specification: state => state.listing.specification
            })
        },
        methods: {
            getAvailableLink(item) {
                let link = (item.CTAUrl != null && item.CTAUrl != "") ? item.CTAUrl : item.Cta.Url;
                if (link.startsWith("~")) link = this.removeInitialTilde(link);
                return link;
            },
            removeInitialTilde(url) {
                return url.replace("~", "");
            },
            getCategories(item) {
                if (typeof (item.TopicsNames) !== 'undefined' && item.TopicsNames.length > 0) {
                    let topics = [...item.TopicsNames];

                    if (this.specification && this.specification.Type && this.specification.Type.split(',').length > 0) {
                        topics = this.orderTopics(topics, this.specification.Type.split(','));
                    }
                    if (this.specification && this.specification.Topic && this.specification.Topic.split(',').length > 0) {
                        topics = this.orderTopics(topics, this.specification.Topic.split(','));
                    }
                    return topics.slice(0, 2).join(', ');
                }
                return '';
            },
            orderTopics(topics, orderArray) {
                let ordered = [...topics];
    
                let placed = [];
    
                orderArray.forEach(orderItem => {
                    const index = ordered.findIndex(topic => topic === orderItem);
                    if (index !== -1) {
                        placed.push(ordered[index]);
                        ordered.splice(index, 1);
                    }
                });
    
                return [...placed, ...ordered];
            },
            formatDate(From, To) {
                const from = moment.utc(From);
                const to = To ? moment.utc(To) : null;
                let dateString = from.format('MMM D, YYYY');
                if (!to || to.year() === 1) return dateString;

                if (from.format('MMM') !== to.format('MMM')) {
                    return `${from.format('MMM D')} - ${to.format('MMM D, YYYY')}`;
                }
                return `${from.format('MMM D')} - ${to.format('D, YYYY')}`;
            }
        }
    }
</script>